import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  form: {
    padding: theme.spacing(2),
  },
}));

export const Form = styled.form`
  width: 100%;
`;
